'use client';
import React, { useContext, useEffect, useRef } from 'react';
import Script from 'next/script';
import PiwikPro, * as PiwikProServices from '@piwikpro/react-piwik-pro';
import { VERSION } from '../version';
var PiwikProContext = React.createContext(PiwikProServices);
export var PiwikProProvider = function (_a) {
    var children = _a.children, containerId = _a.containerId, containerUrl = _a.containerUrl, nonce = _a.nonce, dataLayerName = _a.dataLayerName;
    var hasInitialized = useRef(false);
    if (!containerId) {
        throw new Error('Empty containerId for Piwik PRO.');
    }
    if (!containerUrl) {
        throw new Error('Empty containerUrl for Piwik PRO.');
    }
    useEffect(function () {
        if (hasInitialized.current)
            return;
        if (typeof window !== 'undefined') {
            PiwikProServices.Miscellaneous.setTrackingSourceProvider('nextjs', VERSION);
        }
        if (dataLayerName) {
            PiwikProServices.DataLayer.setDataLayerName(dataLayerName);
        }
        hasInitialized.current = true;
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Script, { id: "piwik-tag-manager-".concat(containerId), strategy: 'afterInteractive', nonce: nonce }, "".concat(PiwikPro.getInitScript({
            containerId: containerId,
            containerUrl: containerUrl,
            dataLayerName: dataLayerName
        }), "\n    ")),
        React.createElement(PiwikProContext.Provider, { value: PiwikProServices }, children)));
};
export var usePiwikPro = function () {
    return useContext(PiwikProContext);
};
//# sourceMappingURL=index.js.map